import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';

import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { GraphQLModule } from './graphql.module';
import { AppRoutingModule } from './app-routing-module';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { IConfig, NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';

export const options: Partial<IConfig> | (() => Partial<IConfig>) = {};

import { 
  ApiService, 
  AppMaterialComponentsModule, 
  LicensedDesignProfessionalApiService, 
  LicensedDesignProfessionalGqlService, 
  ZipCodeApiService, ZipCodeGqlService, 
  LicensedDesignProfessionalSearchModule,
  DialogSolutionDeployingComponent
} from '@ebb-v2/ebb-integration';

import { LicensedDesignProfessionalSearchAppComponent } from './app.component';
import { FlexLayoutModule, FlexModule } from '@angular/flex-layout';
import { AppLoadService } from './app-load-service';

export function get_environ_settings(appLoadService: AppLoadService) {
  return () => appLoadService.getEnvironSettings();
}

@NgModule({
  declarations: [
    LicensedDesignProfessionalSearchAppComponent,
    DialogSolutionDeployingComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    FlexModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    CommonModule,
    HttpClientModule,
    AppMaterialComponentsModule,
    AppRoutingModule,
    FormsModule,
    GraphQLModule,
    LicensedDesignProfessionalSearchModule,
    NgxMaskDirective, NgxMaskPipe
  ],
  providers: [
    ApiService,provideNgxMask(),
    AppLoadService,
    { provide: APP_INITIALIZER, useFactory: get_environ_settings, deps: [AppLoadService], multi: true },
    { provide: LicensedDesignProfessionalApiService, useClass: LicensedDesignProfessionalGqlService },
    { provide: ZipCodeApiService, useClass: ZipCodeGqlService },
  ],
  bootstrap: [LicensedDesignProfessionalSearchAppComponent]
})
export class LicensedDesignProfessionalSearchAppModule {}
